import {
    formatDateNoTime,
    formatYDM,
    getToken,
    getToken2,
    getUser,
    getTime12,
} from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";
import Moment from "moment";
import formData from "react-form-data";

//GET
export const getSchedule = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "employee_schedules/search",
            {
                requester: getUser(),
                token: getToken(),
                schedule_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteSchedule = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "employee_schedules/delete",
            {
                requester: getUser(),
                token: getToken(),
                schedule_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteScheduleMultiple = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "employee_schedules/bulk_delete",
            {
                requester: getUser(),
                token: getToken(),
                schedule_ids: data.map((sched) => {
                    return sched.id
                }),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getAllSchedule = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "employee_schedules/search",
            {
                requester: getUser(),
                token: getToken(),
                schedule_id: data.schedule_id,
                branch_id: data.branch_id,
                employee_id: data.employee_id,
                employee_name: data.employee_name,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getDayoffPerEmployee = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/get_dayoff_per_employee",
            {
                requester: getUser(),
                token: getToken(),
                employee_id: data.employee_id,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// SCHEDULER REPORT API
export const getAllSchedulerReport = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "scheduler_report/search",
            {
                requester: getUser(),
                token: getToken(),
                employee_id: data.employee_id,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// UNDERTIME REPORT API
export const getUndertimeReport = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/get_undertime",
            {
                requester: getUser(),
                token: getToken(),
                employee_id: data.employee_id,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


// OVERTIME REPORT API
export const getOvertimeReport = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "reports/get_employees_overtime_report",
            {
                requester: getUser(),
                token: getToken(),
                department: data.department,
                employee_type: data.employee_type,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// UNDERTIME REPORT BREAKDOWN API
export const getUndertimeReportBreakdown = async (data, id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/get_undertime_breakdown",
            {
                requester: getUser(),
                token: getToken(),
                employee_id: id,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


// UNFOLLOWED BREAK REPORT API
export const getUnfollowedBreakReport = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/get_unfollowed_breaks",
            {
                requester: getUser(),
                token: getToken(),
                employee_id: data.employee_id,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


// UNFOLLOWED BREAK REPORT API
export const getUnfollowedBreakReportBreakdown = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/get_unfollowed_breaks_breakdown",
            {
                requester: getUser(),
                token: getToken(),
                employee_id: data.employee_id,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const createSchedule = async (details, data) => {
    
    

    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            branch_id: details.branch_id,
            date: details.date,

            employee_id: data[0].employee_id,
            employee_name: data[0].employee_id_value.label,
            time_start: data[0].time_start,
            time_end: data[0].time_end,
            hours_total: data[0].hours_total,
            break_time: data[0].break_time,
            break_end: data[0].break_end,
            break_hours: data[0].break_hours,
        };

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "employee_schedules/create",
            payload
        );
        
        return { data: response.data };
    } catch (error) {
        
        return { error: error.response };
    }
};


export const createScheduleMultiple = async (details, data) => {

    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            branch_id: details.branch_id,
            date_from: details.date_from,
            date_to: details.date_to,

            employees: data.map((sched) => {
                return sched.employee_id
            }),
            employee_names: data.map((sched) => {
                return sched.employee_id_value.label
            }),
            time_start: data.map((sched) => {
                return sched.time_start
            }),
            break_time: data.map((sched) => {
                return sched.break_time
            }),
            break_end: data.map((sched) => {
                return sched.break_end
            }),
            break_hours: data.map((sched) => {
                return sched.break_hours
            }),
            time_end: data.map((sched) => {
                return sched.time_end
            }),
            hours_total: data.map((sched) => {
                return sched.hours_total
            }),
            dayoff: data.map((sched) => {
                
                var day = sched.selected_days?.map((data) => {
                    
                    return Moment(data.value).format("YYYY-MM-DD")
                })
                return day
            }),
        };

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "employee_schedules/generate",
            payload
        );
        
        return { data: response.data };
    } catch (error) {
        
        return { error: error.response };
    }
};

export const updateSchedule = async (details, data) => {
    
    

    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            schedule_id: details.id,
            branch_id: details.branch_id,
            date: details.date,

            employee_id: data[0].employee_id,
            employee_name: data[0].employee_name,
            time_start: data[0].time_start,
            time_end: data[0].time_end,
            hours_total: data[0].hours_total,
            break_time: data[0].break_time,
            break_end: data[0].break_end,
            break_hours: data[0].break_hours,
        };

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "employee_schedules/update",
            payload
        );
        
        return { data: response.data };
    } catch (error) {
        
        return { error: error.response };
    }
};

// -----------------POTATO-----------------------

export const getAllSchedulePotato = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "employee_schedules/search",
            {
                requester: getUser(),
                token: getToken2(),
                schedule_id: data.schedule_id,
                branch_id: data.branch_id,
                employee_id: data.employee_id,
                employee_name: data.employee_name,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const deleteScheduleMultiplePotato = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "employee_schedules/bulk_delete",
            {
                requester: getUser(),
                token: getToken2(),
                schedule_ids: data.map((sched) => {
                    return sched.id
                }),
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getSchedulePotato = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "employee_schedules/search",
            {
                requester: getUser(),
                token: getToken2(),
                schedule_id: id,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const createSchedulePotato = async (details, data) => {
    
    

    try {
        var payload = {
            requester: getUser(),
            token: getToken2(),
            branch_id: details.branch_id,
            date: details.date,

            employee_id: data[0].employee_id,
            employee_name: data[0].employee_id_value.label,
            time_start: data[0].time_start,
            time_end: data[0].time_end,
            hours_total: data[0].hours_total,
            break_time: data[0].break_time,
            break_end: data[0].break_end,
            break_hours: data[0].break_hours,
        };

        const response = await postAPICall(
            process.env.REACT_APP_POTATO + "employee_schedules/create",
            payload, "potato"
        );
        
        return { data: response.data };
    } catch (error) {
        
        return { error: error.response };
    }
};


export const createScheduleMultiplePotato = async (details, data) => {

    try {
        var payload = {
            requester: getUser(),
            token: getToken2(),
            branch_id: details.branch_id,
            date_from: details.date_from,
            date_to: details.date_to,
            
            employees: data.map((sched) => {
                return sched.employee_id
            }),
            employee_names: data.map((sched) => {
                return sched.employee_id_value.label
            }),
            time_start: data.map((sched) => {
                return sched.time_start
            }),
            break_time: data.map((sched) => {
                return sched.break_time
            }),
            break_end: data.map((sched) => {
                return sched.break_end
            }),
            break_hours: data.map((sched) => {
                return sched.break_hours
            }),
            time_end: data.map((sched) => {
                return sched.time_end
            }),
            hours_total: data.map((sched) => {
                return sched.hours_total
            }),
            dayoff: data.map((sched) => {
                
                var day = sched.selected_days?.map((data) => {
                    
                    return Moment(data.value).format("YYYY-MM-DD")
                })
                return day
            }),
        };

        const response = await postAPICall(
            process.env.REACT_APP_POTATO + "employee_schedules/generate",
            payload, "potato"
        );
        
        return { data: response.data };
    } catch (error) {
        
        return { error: error.response };
    }
};

export const updateSchedulePotato = async (details, data) => {
    
    

    try {
        var payload = {
            requester: getUser(),
            token: getToken2(),
            schedule_id: details.id,
            branch_id: details.branch_id,
            date: details.date,

            employee_id: data[0].employee_id,
            employee_name: data[0].employee_name,
            time_start: data[0].time_start,
            time_end: data[0].time_end,
            hours_total: data[0].hours_total,
            break_time: data[0].break_time,
            break_end: data[0].break_end,
            break_hours: data[0].break_hours,
        };

        const response = await postAPICall(
            process.env.REACT_APP_POTATO + "employee_schedules/update",
            payload, "potato"
        );
        
        return { data: response.data };
    } catch (error) {
        
        return { error: error.response };
    }
};